/**
 * @module mapbs.components.reportpanel.reportpanel
 */
import angular from 'angular';

import mapbsErdbebenmikrozonierung from 'mapbs/components/reportpanel/erdbebenmikrozonierung/erdbebenmikrozonierung';
import mapbsKleinbautenausschnitt from 'mapbs/components/reportpanel/kleinbautenausschnitt/kleinbautenausschnitt';
import mapbsLiegenschaftskenndaten from 'mapbs/components/reportpanel/liegenschaftskenndaten/liegenschaftskenndaten';
import mapbsEgtarea from 'mapbs/components/reportpanel/egtarea/egtarea';
import mapbsSimplereport from 'mapbs/components/reportpanel/simplereport/simplereport';
import ngeoLocation from 'ngeo/statemanager/Location.js';

const moduleReportpanel = angular.module('mapbsReportpanelModule', [
    mapbsErdbebenmikrozonierung.name,
    mapbsKleinbautenausschnitt.name,
    mapbsLiegenschaftskenndaten.name,
    mapbsSimplereport.name,
    mapbsEgtarea.name,
    ngeoLocation.name,
]);

moduleReportpanel.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/reportpanel', require('./reportpanel.html'));
    }
);

/** @type {!angular.Component} */
const ReportpanelComponent = {
    controller: 'mapbsReportpanelController as ctrl',
    templateUrl: 'mapbs/reportpanel',
    bindings: {
        'map': '<mapbsReportpanelMap',
        'reportPanelActive': '<mapbsReportpanelActive',
        'reportPanelStateActive': '<mapbsReportpanelStateActive',
        'gmfUser': '<mapbsAuthenticationUser',
    },
};

moduleReportpanel.component('mapbsReportpanel', ReportpanelComponent);

class ReportpanelController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @param {angular.$injector} $injector
   * @param {ngeo.statemanager.Location} ngeoLocation ngeo Location service.
   * @private
   * @ngInject
   */
    constructor($scope, $injector, ngeoLocation) {
    /**
     * @param {angular.Scope}
     * @private
     */
        this.scope = $scope;

        /**
     * @type {!ngeo.statemanager.Location}
     * @private
     */
        this.ngeoLocation_ = ngeoLocation;

        /** @type {boolean} */
        this.reportPanelActive;

        /** @type {boolean} */
        this.reportPanelStateActive;

        this.gmfUser;

        /** @type {boolean} @export */
        this.showEgtAreaComponent = false;

        /** @type {boolean} @export */
        this.showLiegRiehen = false;

        this.showHochstammobstbaeumeKennzahlen;

        /** @type {boolean} */
        this.showHochstammobstbaeumeSerienbrief;

        /** @type {boolean} */
        this.showHochstammobstbaeumeKontierung;

        /** @type {boolean} */
        this.showKleinbautenAusschnittReport;

        /** @type {boolean} */
        this.showKleinbautenKennzahlen;

        // listen on take focus of child, broadcast to all child
        this.scope.$on('takefocus', (event, name) => {
            this.scope.$broadcast('tookfocus', name);
        });

        // watch / react on closing the reportpanel
        this.scope.$watch(
            () => {
                return this.reportPanelActive;
            },
            (newVal) => {
                if (!newVal) {
                    this.scope.$broadcast('reportpanelclose');
                } else {
                    this.loadSettings();
                }
            }
        );

        // watch / react on User permisseions
        this.scope.$watch(
            () => {
                return this.gmfUser.username;
            },
            () => {
                if (this.gmfUser.username !== null) {
                    this.loadSettings();
                }
            }
        );
    }

    loadSettings() {
    // watch / react on closing the reportpanel

        if (this.gmfUser.username === null) {
            this.authorizedplugins = [];
            this.showLiegRiehen = false;
            this.showLiegenschaftskenndatenComponent = false;
            this.showHochstammobstbaeumeKennzahlen = false;
            this.showHochstammobstbaeumeSerienbrief = false;
            this.showHochstammobstbaeumeKontierung = false;
            this.showKleinbautenAusschnittReport = false;
            this.showKleinbautenKennzahlen = false;
            this.showEgtAreaComponent = false;

            return;
        }
        const authorizedplugins =
      this.gmfUser['functionalities']['authorized_plugins'];

        if (authorizedplugins.indexOf('plugin_eigentumsauskunft_area') > -1) {
            this.showEgtAreaComponent = true;
        }
        if (authorizedplugins.indexOf('plugin_kb_kennzahlen') > -1) {
            this.showKleinbautenKennzahlen = true;
        }
        if (authorizedplugins.indexOf('plugin_kb_report') > -1) {
            this.showKleinbautenAusschnittReport = true;
        }
        if (
            authorizedplugins.indexOf('plugin_liegenschaftskenndaten_riehen') > -1
        ) {
            this.showLiegRiehen = true;
        }
        if (authorizedplugins.indexOf('plugin_ho_fachdaten') > -1) {
            this.showHochstammobstbaeumeKennzahlen = true;
        }
        if (authorizedplugins.indexOf('plugin_ho_datenerfassung') > -1) {
            this.showHochstammobstbaeumeKennzahlen = true;
            this.showHochstammobstbaeumeSerienbrief = true;
            this.showHochstammobstbaeumeKontierung = true;
        }
    }
}
moduleReportpanel.controller('mapbsReportpanelController', ReportpanelController);

export default moduleReportpanel;
